var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_vm._t("activator",null,{"on":_vm.onHandler}),_vm._v(" "),_c('div',{staticClass:"menu-popout",on:{"click":_vm.onContentClick}},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }